// DashboardStaleModal.tsx
import React from 'react';
import { LightModal } from 'apps/sigma2-ui/src/components/ui/LightModal';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DashboardStaleModal = ({
  show,
  onConfirm,
}: {
  show: boolean;
  onConfirm: () => void;
}) => {
  const language = useLanguage();

  return (
    <LightModal
      showModal={show}
      onClose={onConfirm}
      width="w-1/2 max-w-md"
      title={
        <S2Typography
          translatedContent={language.dashboardUpdatedElsewhere()}
          variant="headline-6"
        />
      }
      actions={
        <PrimaryButtonLightBg
          translatedContent={language.reloadDashboard()}
          onClick={onConfirm}
          disabled={false}
        />
      }
    >
      <S2Typography
        translatedContent={language.dashboardUpdatedElsewhereWarning()}
        variant="body-6"
      />
    </LightModal>
  );
};
